export default __webpack_public_path__ + "static/media/bogota.6ce20218.png";